import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "submit"];

  connect() {
    this.disable();
  }

  validate() {
    if (!this.hasInputTarget || !this.hasSubmitTarget) return;
    const enabled = this.inputTarget.value === 'DELETE';
    this.submitTarget.disabled = !enabled;
  }

  disable() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = true;
  }
}
